const formatDisplayPrice = (price, displayAsInt = false) => {
  if (price === undefined || Number.isNaN(+price)) {
    return ''
  }
  const num = +price

  if (Number.isInteger(num) && displayAsInt) {
    return num.toFixed(0)
  }
  return num.toFixed(2)
}

export default formatDisplayPrice
